import { render } from "./SubCommentList.vue?vue&type=template&id=7abf9029"
import script from "./SubCommentList.vue?vue&type=script&lang=js"
export * from "./SubCommentList.vue?vue&type=script&lang=js"

import "./SubCommentList.vue?vue&type=style&index=0&id=7abf9029&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__